import { Alert02Icon, CheckmarkBadge02Icon } from '@hugeicons-pro/core-solid-rounded';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './VerificationBadge.module.scss';

const typeColors = {
  success: '#039d41',
  warning: '#d96800',
};

export const VerificationBadge = ({ type = 'success', tip = '', className = '' }) => {
  return (
    <OverlayTrigger
      trigger={tip ? ['hover', 'focus'] : 'none'}
      placement="bottom"
      overlay={<Tooltip>{tip}</Tooltip>}>
      <div className={cn(styles.root, styles[`root--${type}`], { [className]: className })}>
        <HugeiconsIcon
          size={20}
          icon={type === 'success' ? CheckmarkBadge02Icon : Alert02Icon}
          color={typeColors[type]}
        />
      </div>
    </OverlayTrigger>
  );
};
